import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const MultiSelectWrapper = styled.div`
  .CMultiSelect {
    font-family: ${theme.fonts.Regular};
    position: relative;
    width: 100%;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    label {
      p {
        display: inline-block;
        font-size: 13px;
        color: ${theme.colours.gray2};
        margin-bottom: 8px;
        span {
          color: ${theme.colours.error};
          font-size: 15px;
        }
      }
    }
    .input.hasError {
      border: 1px solid ${theme.colours.error} !important;
    }
    .valueInfo {
      width: 5px;
      height: 5px;
      background-color: #dc2d2d;
      border-radius: 50%;
      position: absolute;
      top: 8px;
      right: 13px;
    }
    .input {
      position: relative;
      background-color: ${theme.colours.Lotion};
      border: 1px solid ${theme.colours.BrightGray};
      border-radius: 12px;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      p {
        color: ${theme.colours.blackText} !important;
        font-size: 14px;
        white-space: nowrap;
      }
      svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        &:lang(ar) {
          left: 20px;
        }
        &:lang(en) {
          right: 20px;
        }
        width: 16px;
        min-width: 16px;
        height: 16px;
      }
      cursor: pointer;
    }
    .dropdown-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      background-color: ${theme.colours.white};
      transition: 250ms;
      outline: 1px solid ${theme.colours.white};
      color: #fff;
      border-top: none;
      border-radius: 8px;
      margin-top: 10px;
      max-height: 340px;
      overflow-y: auto;
      position: absolute;
      top: 100%;
      height: 0;
      opacity: 0;
      z-index: 9999;
      min-width: 100%;
      width: fit-content;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
      li {
        display: flex;
        align-items: center;
        padding: 0 12px;
        gap: 12px;
        color: ${theme.colours.black_2};
        label {
          padding: 5px 0;
          white-space: nowrap;
        }
        input[type='checkbox'] {
          height: 24px;
          width: 24px;
        }
        label.header-label {
          font-size: 16px;
          color: ${theme.colours.gray2};
          font-weight: 600;
        }
      }
    }
    &.active {
      .dropdown-container {
        transition: all ease-in-out 0.2s;
        opacity: 1;
        height: auto;
      }
    }
    &.disabled {
      background-color: ${theme.colours.Cultured};
      padding: 0 6px;
      border-radius: 4px;
      pointer-events: none;
      cursor: not-allowed;
    }
  }
`;
